import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { excelExportDateFormat } from 'projects/common/src/app/services/utils/util.service';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { ReportExplosiveService } from '../../services/report-explosive.service';
import { ReportExplosiveModalComponent } from './report-explosive-modal/report-explosive-modal.component';

@Component({
  selector: 'app-report-explosive',
  templateUrl: './report-explosive.component.html',
  styleUrls: ['./report-explosive.component.scss'],
})
export class ReportExplosiveComponent implements OnInit {
  public tableConfig: ITableConfig;
  public selectedFilters: IOutputFilter;
  public resultExplosive: any;
  public message: string;
  public systemError: string;
  public filterConfig: IFilterConfig;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    private reportExplosiveService: ReportExplosiveService,
    private tableService: TableConfigService,
    private layoutConfigService: LayoutConfigService,
    private modalService: NgbModal,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
  ) {
    this.filterConfig = {
      dates: { required: true },
      cleanButton: true,
    };
    this.disabledExcelBtn = false;
  }

  /**
   * Init Component
   */
  public ngOnInit(): void {
    const layoutConfig: ILayoutConfig = {
      title: 'reports',
      subtitle: 'report-explosives',
      imageKey: 'report',
      imageType: 'section',
    };

    this.layoutConfigService.setConfig(layoutConfig);
  }

  /**
   * get data report Explosive
   */
  public getReportExplosive(selectedFilters: IOutputFilter): void {
    this.filterConfig.isLoading = true;
    this.selectedFilters = selectedFilters;
    this.reportExplosiveService.getReportExplosiveData(this.selectedFilters).then((result) => {
      const tableData = [];

      for (const explosive of result) {
        tableData.push({
          zoneId: explosive.zoneId,
          zoneName: explosive.zoneName,
          conditionName: explosive.conditionName,
          conditionSourceName: explosive.conditionSourceName,
          conditionDate: explosive.conditionDate,
          apD450: explosive.apD450,
          apD900: explosive.apD900,
          apD1500: explosive.apD1500,
          tronex: explosive.tronex,
          barraFCK: explosive.barraFCK === false ? 'NO' : 'SI',
          detonadores: explosive.detonadores,
          famebat: explosive.famebat,
          famepast: explosive.famepast,
          operatorName: explosive.operatorName,
          detalle: 'Ver',
        });
      }
      this.filterConfig.isLoading = false;
      this.setTableConfigExplosive(tableData);
    });
    const filters = {
      reports: 'report-explosive',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * set Config table Explosive
   */
  public setTableConfigExplosive(tableData: any[]): void {
    const excludeColumns = [
      'zoneId',
      'conditionId',
      'conditionSourceId',
      'conditionLogSyncId',
      'explosiveConditionHistory',
      'apD450',
      'apD900',
      'apD1500',
      'barraFCK',
      'famebat',
      'famepast',
      'tronex',
      'detonadores',
    ];

    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns,
      replaceColumnName: [
        { prevName: 'zoneName', newName: 'zone' },
        { prevName: 'conditionName', newName: 'spot condition' },
        { prevName: 'conditionSourceName', newName: 'profile_group' },
        { prevName: 'conditionDate', newName: 'date-condition' },
        { prevName: 'barraFCK', newName: 'barrafck' },
        { prevName: 'operatorName', newName: 'operator-user' },
      ],
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns,
      clickConfig: [{ field: 'detalle', hasBoldHover: true, hasCursorPointer: true }],
      dateConfig: [
        { field: 'conditionDate', format: 'date-time' },
        { field: 'createdAt', format: 'date-time' },
      ],
    };

    const { header, dataset } = this.tableService.setTableMainConfig(headerParams, datasetParams);

    this.tableConfig = { header, dataset };
  }

  /**
   *
   * Click column table
   */
  public async clickColumnHistorial(event): Promise<void> {
    const zoneName = event.row.find((z) => z.key === 'zoneName');
    const data = await this.reportExplosiveService.getReportExplosiveData(this.selectedFilters);

    const componentRef = this.modalService.open(ReportExplosiveModalComponent, {
      centered: true,
      size: 'lg',
      windowClass: 'prod-street-modal-width',
    });
    componentRef.componentInstance.zoneName = zoneName.value;
    componentRef.componentInstance.data = data;
  }

  /**
   * Download excel file
   *
   */
  public async downloadExcelFile(): Promise<void> {
    const selectRangeDate = {
      startDate: excelExportDateFormat(this.selectedFilters.startDate),
      endDate: excelExportDateFormat(this.selectedFilters.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.reportExplosiveService.getReportExplosiveExcel(this.selectedFilters).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'explosive-report-excel-filename', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
